import React from 'react'
import {Link} from 'react-router'
import {withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import {Form, Field} from 'simple-react-form'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import getQueryParam from 'orionsoft-parts/lib/helpers/getQueryParam'
import {createUser} from 'App/helpers/meteor-apollo-accounts'

import SimpleCheckBox from 'App/components/fields/SimpleCheckBox'
import availableCountries from 'App/helpers/countries/available'
import track from 'App/helpers/track'
import translate from 'App/i18n/translate'
import Translate from 'App/i18n'

import ReferralLabel from './ReferralLabel'
import Text from './Text'
import TOS from './TOS'
import styles from './styles.css'

@withApollo
export default class Register extends React.Component {
  static propTypes = {
    setLoading: PropTypes.func,
    setError: PropTypes.func,
    onSuccess: PropTypes.func,
    isLoading: PropTypes.bool,
    client: PropTypes.object
  }

  state = {}

  componentDidMount() {
    const email = getQueryParam('email')
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const ref = urlParams.get('refId')
    ref && localStorage.setItem('refId', ref)

    let originToken = urlParams.get('originToken')
    originToken && localStorage.setItem('originToken', originToken)

    const utmSource = urlParams.get('utm_source')
    utmSource && localStorage.setItem('utm_source', utmSource)
    const utmMedium = urlParams.get('utm_medium')
    utmMedium && localStorage.setItem('utm_medium', utmMedium)
    const utmCampaign = urlParams.get('utm_campaign')
    utmCampaign && localStorage.setItem('utm_campaign', utmCampaign)
    const utmTerm = urlParams.get('utm_term')
    utmTerm && localStorage.setItem('utm_term', utmTerm)
    const utmContent = urlParams.get('utm_content')
    utmContent && localStorage.setItem('utm_content', utmContent)

    if (email) this.setState({email})
    if (ref) this.setState({profile: {referredBy: ref}})
    if (originToken) {
      this.setState({profile: {originToken}})
    } else if (utmSource || utmMedium || utmCampaign || utmTerm || utmContent) {
      originToken = 'utm_source:' + utmSource + '|utm_medium:' + utmMedium + '|utm_campaign:' + utmCampaign + '|utm_term:' + utmTerm + '|utm_content:' + utmContent
      this.setState({profile: {originToken}})
    }

  }

  @autobind
  async login() {
    if (!this.canRegister()) return
    if (!this.state.accept) {
      return this.props.setError('Debes aceptar los terminos y la política de privacidad')
    }
    if (this.state.password !== this.state.confirm) {
      return this.props.setError(<Translate tr="auth.pages.passwordDoesntMatch" />)
    }
    if (!this.state.profile || !this.state.profile.countryCode) {
      return this.props.setError('Debes indicar el país de residencia')
    }
    this.props.setLoading(true)
    this.props.setError(null)
    try {
      await createUser(this.state, this.props.client)
      track({action: 'register', category: 'auth', label: this.state.email})
      if (localStorage.getItem('originToken') === 'twitter') {
        window.twq && window.twq('event', 'tw-oeqwu-oerpw')
      }
      this.props.onSuccess()
    } catch (e) {
      console.error(e)
      track({action: 'register-error', category: 'auth', label: e.message})
      this.props.setError(e.message)
      this.props.setLoading(false)
    }
  }

  @autobind
  handleConfirmKey(event) {
    if (event.charCode === 13 || event.keyCode === 13) {
      this.login()
    }
  }

  canRegister() {
    return this.state.email && this.state.password && this.state.confirm
  }

  renderButtons() {
    return (
      <div className={styles.buttonsContainer}>
        <Button
          disabled={!this.canRegister()}
          primary
          onClick={this.login}
          className="tds-orionx-override-btn"
          fullWidth
          loading={this.props.isLoading}>
          <Translate tr="auth.pages.register" />
        </Button>
      </div>
    )
  }

  render() {
    const referredBy = localStorage.getItem('refId')

    return (
      <div className={styles.formContainer}>
        {referredBy && <ReferralLabel refId={referredBy} />}
        <Form state={this.state} onChange={changes => this.setState(changes)} onSubmit={this.login}>
          <Field
            fieldName="email"
            type={Text}
            fieldType="email"
            className="tds-orionx-input"
            placeholder={translate('auth.pages.email')}
          />
          <br />
          <Field
            fieldName="password"
            type={Text}
            fieldType="password"
            className="tds-orionx-input"
            placeholder={translate('auth.pages.password')}
          />
          <br />
          <Field
            fieldName="confirm"
            type={Text}
            fieldType="password"
            className="tds-orionx-input"
            placeholder={translate('auth.pages.confirmPassword')}
            onKeyPress={this.handleConfirmKey}
          />
          <br />
          <Field
            fieldName="profile.countryCode"
            type={Select}
            placeholder={translate('auth.pages.country')}
            style={{backgroundColor: '#fff'}}
            className="tds-orionx-override-dropdown"
            options={availableCountries}
          />
          <br />
          <Field fieldName="accept" type={SimpleCheckBox}>
            Acepto la{' '}
            <Link to="/privacy-policy" target="_blank">
              Política de privacidad
            </Link>{' '}
            y los{' '}
            <Link to="/terms-and-conditions" target="_blank">
              Términos y condiciones
            </Link>
          </Field>
        </Form>
        {this.renderButtons()}
        <br />
        <Translate tr="auth.pages.otherLinksInRegister" />
        <br />
        <TOS />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Register.js